define('modules/icons/icon_model',['backbone'], function(Backbone) {
   'use strict';
    var Model = Backbone.Model.extend({
      defaults: {
        name: '',
        show_badge: true,
        count: 0
      }
    });

    return Model;
});
